var map = {
	"./card-flags.png": "6180",
	"./collectables/website-store-tiles-01-1_low_lay-flat-albums.jpeg": "1c78",
	"./collectables/website-store-tiles-01-2_low_matted-frames.jpeg": "deca",
	"./collectables/website-store-tiles-01-3_low_calendars.jpeg": "d529",
	"./collectables/website-store-tiles-01-4_low_prints.jpeg": "217a",
	"./collectables/website-store-tiles-01-5_low_print-box.jpeg": "620d",
	"./collectables/website-store-tiles-01-6_low_greeting-cards.jpeg": "cbfc",
	"./default-media-thumb.png": "a00c",
	"./logo-iugu.png": "7cfa",
	"./logo_fottorama_grey.png": "e7cb",
	"./logo_pequeno.png": "f389"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";